<template>
  <section class="landingPage">
    <section class="mainContainer">
      <img :src="image" alt="highgrounds-city-scape">
      <div class="containerTinter"></div>
      <div class="text">ABOUT</div>
    </section>
  </section>
</template>

<script>
import CityScape from '@/assets/hgAbout/cityScape.jpg';

export default {
  name: 'LandingPage',
  data() {
    return {
      image: CityScape
    }
  },
}
</script>

<style scoped>
@media (max-width: 1400px) {
  .landingPage {
    position: relative;
    height: auto;
    width: 100%;
  }
  .mainContainer {
    height: auto;
    width: 100%;
  }
  .mainContainer > img {
    height: auto;
    width: 100%;
    background: no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;    
    -o-background-size: cover;      
    background-size: cover;
  }
}
@media (min-width: 1400px) {
  .landingPage {
    position: relative;
    height: auto;
    width: 100%;
  }
  .mainContainer {
    height: 65rem;
    width: 85rem;
  }
  .mainContainer > img {
    position: absolute;
    top:0;
    bottom: 0;
    right: 0;
    left: 0;
    height: auto;
    width: 100%;
    background: no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;    
    -o-background-size: cover;      
    background-size: cover;
  }
}
.mainContainer .containerTinter {
  background-image: linear-gradient(
    to top,
    #1E1E1E 0%,
    #1E1E1E 20%,
    rgb(0,0,0,0.0) 80%
  );
  position: absolute;
  bottom: 0;
  height: 100%;
  width: 100%;
}
.mainContainer .text {
  position: absolute;
  right: 5rem;
  bottom: 15rem;
  color: white;
  font-size: 9vw;
}
</style>
